(() => {
  const cartPath = document.body.dataset.growthlabCartUrl;
  if (!cartPath || document.body.dataset.growthlabCartNavigation) return;
  document.body.dataset.growthlabCartNavigation = 'true';
  let opening = false;
  const openDrawer = async () => {
    if (document.querySelector('dialog[open] cart-drawer') || opening) return;
    opening = true;
    let timer;
    try {
      await Promise.race([customElements.whenDefined('cart-drawer-trigger'), new Promise((_, reject) => { timer = setTimeout(reject, 10000); })]);
      const trigger = document.querySelector('cart-drawer-trigger');
      if (!trigger) throw new Error('Cart trigger unavailable');
      trigger.click();
    } catch {
      if (location.pathname.replace(/\/$/, '') !== cartPath.replace(/\/$/, '')) location.assign(cartPath);
    } finally { clearTimeout(timer); opening = false; }
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || link.target === '_blank') return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname.replace(/\/$/, '') !== cartPath.replace(/\/$/, '')) return;
    if (url.searchParams.get('view') === 'meta' || url.searchParams.has('section_id')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openDrawer();
  }, true);
  if (location.pathname.replace(/\/$/, '') === cartPath.replace(/\/$/, '')) openDrawer();
  const current = new URL(location.href);
  if (current.searchParams.get('growthlab_cart') === 'open') {
    current.searchParams.delete('growthlab_cart');
    history.replaceState(history.state, '', current.href);
    openDrawer();
  }
})();
